<template>
	<div class="begin">
		<el-dialog :title="title" width="540px" :visible.sync="dialogVisible" @close="resetForms('beginFrom')" :show-close="false">
			<div class="mt-12">
				<div class="tipsBox mb-16" v-if="state === 1">
					<el-form :model="checkForm" ref="checkForm" label-width="100px" class="demo-dynamic">
						<el-form-item prop="reason" label="审核结果">
							<el-radio-group v-model="checkValue" size="mini" fill="#2475FF">
								<el-radio label="1" border>通过</el-radio>
								<el-radio label="2" border>拒绝</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item
							v-if="checkValue === '2'"
							prop="reason"
							label="拒绝原因"
							class="mt-12"
							:rules="[{ required: true, message: '请输入拒绝原因', trigger: 'blur' }]"
						>
							<el-input v-model="checkForm.reason" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入拒绝原因"></el-input>
						</el-form-item>
					</el-form>
				</div>
				<div class="tipsBox reject mb-16" v-if="state === 3 && +beginFrom.audit_status === 20">
					<el-form :model="checkForm" ref="checkForm" label-width="100px" class="demo-dynamic">
						<el-form-item prop="reason" label="审核结果" style="color: #fe3665">拒绝</el-form-item>
						<el-form-item prop="reason" label="拒绝原因">{{ beginFrom.rejection_reason || '-' }}</el-form-item>
						<el-form-item prop="reason" label="审核人">{{ beginFrom.audit_username }}</el-form-item>
					</el-form>
				</div>
				<div>
					<product-box :row="row" :tabName="tabName" :is_good_type="is_good_type"></product-box>
				</div>
				<div class="mt-20">
					<user-info-box :row="row"></user-info-box>
				</div>
				<div class="mt-20 form-content">
					<el-form :model="beginFrom" ref="beginFrom">
						<el-form-item label="带货类型：" :label-width="formLabelWidth" prop="sell_goods_type">
							{{ typeMap[+beginFrom.sell_goods_type] || '-' }}
						</el-form-item>
						<el-form-item label="开始合作时间：" :label-width="formLabelWidth" prop="live_time">
							{{ beginFrom.live_time | formatDateTime }}
						</el-form-item>
						<el-form-item label="短视频链接：" :label-width="formLabelWidth" prop="video_url">{{ beginFrom.video_url || '-' }}</el-form-item>
						<el-form-item label="带货截图：" :label-width="formLabelWidth" prop="video_pic">
							<div class="upload-img-box">
								<div class="upload-img" v-for="(item, index) in beginFrom.image_list" :key="index">
									<!-- <img :src="item.image_url" alt="" class="upload-img" /> -->
									<el-image class="upload-img" :src="item.image_url" :preview-src-list="beginFrom.image_list.map(v => v.image_url)"></el-image>
								</div>
							</div>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="beginConfirm">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import productBox from '@/components/common/productBox';
import userInfoBox from '@/components/common/userInfoBox';
import { getDeliveryAuditDetail, deliveryAuditPass, deliveryAuditReject } from '@/api/cooperationProgress';
export default {
	components: {
		productBox,
		userInfoBox,
	},
	name: 'deliver',
	computed: {},
	data() {
		return {
			typeMap: {
				0: '不限',
				1: '直播',
				2: '短视频',
			},
			dialogVisible: false,
			beginFrom: {},
			formLabelWidth: '130px',
			title: '',
			row: {},
			tabName: '',
			state: 0,
			is_good_type: 1,
			checkValue: '1',
			checkForm: {
				reason: '',
			},
		};
	},
	methods: {
		getDetail() {
			getDeliveryAuditDetail({
				cooperate_id: this.row.cooperate_id,
			}).then(res => {
				let info = res.data;
				this.beginFrom = info;
			});
		},
		async initDeliverFun(row, state, tabName) {
			this.tabName = tabName;
			this.state = state;
			this.row = row;
			if (state === 1) {
				this.title = '审核交付内容';
				this.checkForm.reason = '';
				this.checkValue = '1';
			} else if (state === 2) {
				this.title = '查看交付内容';
			} else if (state === 3) {
				this.title = '查看拒绝原因';
			}
			this.dialogVisible = true;
			this.getDetail();
		},
		beginConfirm() {
			if (this.state === 1) {
				// 拒绝原因必填
				if (this.checkValue === '2') {
					this.$refs.checkForm.validate(valid => {
						if (valid) {
							this.handleReject();
						}
					});
				} else {
					this.handlePass();
				}
			}
			this.dialogVisible = false;
		},
		handlePass() {
			deliveryAuditPass({
				cooperate_id: this.row.cooperate_id,
			}).then(res => {
				this.$message.success('操作成功');
				this.$emit('refreshList');
			});
		},
		handleReject() {
			deliveryAuditReject({
				cooperate_id: this.row.cooperate_id,
				rejection_reason: this.checkForm.reason,
			}).then(res => {
				this.$message.success('操作成功');
				this.$emit('refreshList');
			});
		},

		//重置弹框表单
		resetForms(from) {
			this.$refs[from].resetFields();
		},
	},
};
</script>
<style lang="less" scoped>
.tipsBox {
	background: #fbfbfc;
	padding: 12px;
	border-radius: 8px;
	/deep/ .el-form-item__label {
		color: #4e5969;
	}
	/deep/ .el-form-item {
		color: #1d2129;
		margin-bottom: 0;
	}
}
.reject {
	/deep/ .el-form-item--small.el-form-item {
		margin-bottom: 0;
	}
}
.begin {
	/deep/ .el-dialog__body {
		padding: 10px 24px 24px 24px !important;
	}
	/deep/ .el-radio {
		margin-right: 5px;
		margin-left: 5px;
	}
}
.form-content {
	.upload-img-box {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		gap: 12px;
		.upload-img {
			width: 100px;
			height: 100px;
			border-radius: 4px;
		}
	}
	.el-form {
		/deep/ .el-form-item__label {
			color: #4e5969;
		}
		/deep/ .el-form-item {
			color: #1d2129;
		}
		/deep/ .el-form-item--small.el-form-item {
			margin-bottom: 4px;
		}
	}
}
</style>
